export default "__VITE_ASSET__943d0e9c__"